/**
 * Eén schakelaar (off/dry/on) met het env-plafond erbij. De omgeving (env-var) is het plafond; wat je
 * hier kiest telt alleen tot dat plafond. Wijzigen krijgt "ongedaan maken".
 */
import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import { biedOngedaanAan } from '../../../utils/ongedaan';
import { NIVEAU_LABEL } from './api';

const GRIJS = '#556071';

export function effectiefTekst(rij) {
  if (!rij) return '';
  const eff = NIVEAU_LABEL[rij.effectief] || rij.effectief;
  if (rij.env_houdt_tegen) {
    return `Werkt nu als: ${eff} — de omgeving (${rij.naam}=${rij.env}) houdt een hogere stand tegen.`;
  }
  if (rij.env === 'off') return `Werkt nu als: Uit — de omgeving (${rij.naam}) staat uit; hier aanzetten heeft geen effect.`;
  return `Werkt nu als: ${eff}. Plafond in de omgeving: ${NIVEAU_LABEL[rij.env] || rij.env}.`;
}

export default function Schakelaar({ rij, titel, onZet, kanBewerken = true }) {
  if (!rij) return null;
  const huidig = rij.admin || rij.env;
  const zet = async (_e, nieuw) => {
    if (!nieuw || nieuw === huidig) return;
    const vorige = rij.admin || rij.env;
    try {
      await onZet(nieuw);
      biedOngedaanAan(`${titel}: ${NIVEAU_LABEL[nieuw]}`, () => onZet(vorige));
    } catch (e) { toast.error(e.message); }
  };
  return (
    <Box sx={{ py: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ flex: 1, minWidth: 220 }}>
          <Typography sx={{ fontSize: '0.9rem', fontWeight: 600 }}>{titel}</Typography>
          <Typography sx={{ fontSize: '0.78rem', color: GRIJS }}>{rij.uitleg}</Typography>
        </Box>
        <ToggleButtonGroup size="small" exclusive value={huidig} onChange={zet} disabled={!kanBewerken}>
          {['off', 'dry', 'on'].map((n) => (
            <ToggleButton key={n} value={n} sx={{ textTransform: 'none', px: 1.5, py: 0.25 }}>{NIVEAU_LABEL[n]}</ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
      <Typography sx={{ fontSize: '0.76rem', color: rij.env_houdt_tegen ? '#92400e' : GRIJS, mt: 0.5 }}>
        {effectiefTekst(rij)}
      </Typography>
    </Box>
  );
}
